import { render, staticRenderFns } from "./DigitalPrint.vue?vue&type=template&id=2579f852&scoped=true"
import script from "./DigitalPrint.vue?vue&type=script&lang=js"
export * from "./DigitalPrint.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/inbox.css?vue&type=style&index=0&id=2579f852&prod&scoped=true&lang=css&external"
import style1 from "@/assets/css/custom.css?vue&type=style&index=1&id=2579f852&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2579f852",
  null
  
)

export default component.exports